export function getUserPermissions() {

  const token = localStorage.getItem("token");

  if (!token) return [];

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.permissions || [];
  } catch {
    return [];
  }
}
